export const SEPARATOR_CHARACTERS = [",", "."];
